// src/pages/ResumoEventoPage.tsx
import React, { useEffect, useState, useCallback } from "react";
import { api } from "../services/api";
import Sidebar from "../components/Sidebar";
import { useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

interface ResumoEvento {
  eventoId: number;
  descricao: string;
  valorInicialCaixa: number;

  totalReceita: number;     // Somente recebidas (status 1)
  totalPendente: number;    // Fiados pendentes (status 2)
  totalCanceladas: number;    // Canceladas (status 3)
  saldoAtual: number;       // valorInicial + totalReceita

  totaisPorFormaPagamento: {
    forma: string;
    total: number;
  }[];

  totaisPorProduto: {
    produto: string;
    quantidade: number;
    total: number;
  }[];

  totalItensVendidos: number;
  totalVendas: number;
  ticketMedio: number;
  ticketMedioPorItem: number;
}

const ResumoEventoPage: React.FC = () => {
  const { eventoId } = useParams();
  const navigate = useNavigate();

  const [resumo, setResumo] = useState<ResumoEvento | null>(null);
  const [loading, setLoading] = useState(true);

  const carregarResumo = useCallback(async () => {
    try {
      const res = await api.get(`/evento/${eventoId}/resumo`);
      setResumo(res.data);
    } catch (err) {
      console.error(err);
      Swal.fire("Erro", "Falha ao carregar resumo do evento.", "error");
    } finally {
      setLoading(false);
    }
  }, [eventoId]);

  useEffect(() => {
    carregarResumo();
  }, [carregarResumo]);

  if (loading) {
    return (
      <div className="d-flex">
        <Sidebar />
        <div className="flex-grow-1 p-4 text-center">
          <div className="spinner-border text-success" style={{ width: 60, height: 60 }} />
          <p className="mt-3 text-muted">Carregando resumo...</p>
        </div>
      </div>
    );
  }

  if (!resumo) {
    return (
      <div className="d-flex">
        <Sidebar />
        <div className="flex-grow-1 p-4">
          <div className="alert alert-warning">Nenhum resumo encontrado.</div>
        </div>
      </div>
    );
  }

  return (
    <div className="d-flex">
      <Sidebar />

      <div className="flex-grow-1 p-4" style={{ marginLeft: 220 }}>
        <h2 className="mb-4">📊 Resumo do Evento — {resumo.descricao}</h2>

        {/* CAIXA */}
        <div className="card shadow-sm p-3 mb-4">
          <h5 className="mb-3">💵 Caixa</h5>

          <p>Valor inicial: <strong>R$ {resumo.valorInicialCaixa.toFixed(2)}</strong></p>
          <p>Total recebido: <strong>R$ {resumo.totalReceita.toFixed(2)}</strong></p>
          <p>Total pendente: <strong>R$ {resumo.totalPendente.toFixed(2)}</strong></p>
          <p style={{ color: "#b00020", fontWeight: "bold" }}>
            Total canceladas: R$ {resumo.totalCanceladas.toFixed(2)}
          </p>

          <hr />
          <p>
            Saldo atual:{" "}
            <strong style={{ fontSize: 18 }}>
              R$ {resumo.saldoAtual.toFixed(2)}
            </strong>
          </p>
        </div>

        {/* FORMAS DE PAGAMENTO */}
        <div className="card shadow-sm p-3 mb-4">
          <h5 className="mb-3">💳 Por forma de pagamento</h5>

          {resumo.totaisPorFormaPagamento.length > 0 ? (
            resumo.totaisPorFormaPagamento.map((f, index) => (
              <div key={index} className="d-flex justify-content-between border-bottom py-1">
                <span>{f.forma}</span>
                <strong>R$ {f.total.toFixed(2)}</strong>
              </div>
            ))
          ) : (
            <p className="text-muted">Nenhuma venda recebida.</p>
          )}
        </div>

        {/* PRODUTOS */}
        <div className="card shadow-sm p-3 mb-4">
          <h5 className="mb-3">🍔 Vendas por produto</h5>

          {resumo.totaisPorProduto.length > 0 ? (
            resumo.totaisPorProduto.map((p, index) => (
              <div key={index} className="d-flex justify-content-between border-bottom py-1">
                <span>{p.produto} — {p.quantidade} un</span>
                <strong>R$ {p.total.toFixed(2)}</strong>
              </div>
            ))
          ) : (
            <p className="text-muted">Nenhum item vendido.</p>
          )}
        </div>

        {/* TOTAIS */}
        <div className="card shadow-sm p-3 mb-4">
          <h5 className="mb-3">📈 Totais</h5>

          <p>Total de itens vendidos: <strong>{resumo.totalItensVendidos}</strong></p>
          <p>Total de vendas: <strong>{resumo.totalVendas}</strong></p>

          <hr />

          <p>
            Ticket médio (por venda):{" "}
            <strong>
              {(resumo.ticketMedio ?? 0).toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              })}
            </strong>
          </p>

          <p>
            Ticket médio (por item):{" "}
            <strong>
              {(resumo.ticketMedioPorItem ?? 0).toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              })}
            </strong>
          </p>
        </div>

        <button className="btn btn-secondary mt-3" onClick={() => navigate("/eventos")}>
          Voltar
        </button>
      </div>
    </div>
  );
};

export default ResumoEventoPage;

// Corrige erro TS1208
export { };
